import styles from "../LightHouse.module.css"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PointBox from "./PointBox";

function SideNav({ rightNav, outside, setRightNav, setFortuneList, menuList }) {
    const memberId = localStorage.getItem("lighthouse_memberId");
    const socialLoggedIn = localStorage.getItem("lighthouse_socialLoggedIn");
    const isLoggedIn = socialLoggedIn === 'true';
    const hasInfo = memberId && memberId !== 'null' && memberId !== 'undefined';

    const NAVER_CLIENT_ID = 'wjbMqVYTiRku00euvWoQ';
    const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO_CLIENT_ID || 'TEST_KAKAO_KEY';

    const handleNaverLogin = () => {
        // 개발환경과 프로덕션 환경에서 모두 작동하도록
        const baseUrl = window.location.origin;
        const redirectUri = encodeURIComponent(`${baseUrl}/lighthouse/auth/callback/naver`);
        const state = Math.random().toString(36).substring(7);
        localStorage.setItem('naver_state', state);

        console.log('Naver Login Redirect URI:', `${baseUrl}/lighthouse/auth/callback/naver`);

        const naverAuthUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`;
        window.location.href = naverAuthUrl;
    };

    const handleKakaoLogin = () => {
        const redirectUri = encodeURIComponent(`${window.location.origin}/lighthouse/auth/callback/kakao`);

        const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_CLIENT_ID}&redirect_uri=${redirectUri}`;
        window.location.href = kakaoAuthUrl;
    };

    const handleLogout = () => {
        if (window.confirm('로그아웃 하시겠습니까?')) {
            localStorage.removeItem('lighthouse_memberId');
            localStorage.removeItem('lighthouse_socialLoggedIn');
            window.location.reload();
        }
    };

    return (
        <div className={rightNav ? 'sideNav_menu active' : 'sideNav_menu'} ref={outside} onClick={(e) => {
            if (e.target == outside.current) setRightNav(false);
        }}>
            <div className={`sideNav_content ${styles.sideNav_content_lightHouse}`}>
                <div className="logoContent">
                    <Link to="/lighthouse" className="logo">
                        <img src={process.env.PUBLIC_URL + '/image/lightHouse_logo.png'} alt='소원등대' />
                    </Link>
                    <button type="button" className="navClose" onClick={() => { setRightNav(!rightNav); }}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/close.png'} />
                    </button>
                </div>

                {/* 로그인 영역 */}
                {!isLoggedIn ? (
                    <div className="loginSection" style={{
                        padding: '20px 0',
                        borderBottom: '1px solid rgba(255,255,255,0.1)',
                        marginBottom: '15px'
                    }}>
                        <p style={{
                            fontSize: '14px',
                            color: '#aaa',
                            textAlign: 'center',
                            marginBottom: '15px',
                            wordBreak:'keep-all',
                            margin: '0 10px 10px',
                            lineHeight: '1.3'
                        }}>
                            로그인하고 포인트를 모아보세요!
                        </p>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <button
                                className="snsLogin"
                                onClick={handleNaverLogin}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    background: '#03C75A',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.273 12.845L7.376 0H0v24h7.727V11.155L16.624 24H24V0h-7.727v12.845z" fill="white"/>
                                </svg>
                                네이버 로그인
                            </button>
                            <button
                                className="snsLogin"
                                onClick={handleKakaoLogin}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    color: '#000000',
                                    background: '#FEE500',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10 3C5.58172 3 2 5.76903 2 9.16667C2 11.3369 3.48276 13.2355 5.7379 14.3308L4.92683 17.5122C4.86556 17.7529 5.14111 17.9434 5.35006 17.8041L9.21316 15.2321C9.46947 15.2761 9.73218 15.3 10 15.3C14.4183 15.3 18 12.564 18 9.16667C18 5.76903 14.4183 3 10 3Z" fill="#000000"/>
                                </svg>
                                카카오 로그인
                            </button>
                        </div>
                    </div>
                ) : (
                    <div style={{ marginBottom: '15px' }}>
                        <PointBox />
                    </div>
                )}

                {
                    menuList.NAME
                        ?
                        <div className="useProfile">
                            <div className="userImg">
                                <p className="icon">
                                    <img src={process.env.PUBLIC_URL + `${decodeURIComponent(menuList.ZODIAC_ANIMAL)}`} />
                                </p>
                                <img src={process.env.PUBLIC_URL + `${decodeURIComponent(menuList.SEX)}`} />
                            </div>
                            <div className={`userInfo ${styles.userInfo_lightHouse}`}>
                                <h5 className="userName">{menuList.NAME}</h5>
                                <span>{menuList.CONTENT}</span>
                            </div>
                            <div className={`userFortune ${styles.userFortune_lightHouse}`}>
                                <FortuneResult menuList={menuList}></FortuneResult>
                            </div>
                        </div>
                        :
                        <div className="nullUserInfo">
                            <h4>운세를 보기 위해선 기본 정보가 필요해요 !</h4>
                        </div>
                }
                {/* 로그인 시에만 정보 입력/목록 버튼 표시 */}
                {isLoggedIn && (
                    <>
                        <Link to="/lighthouse/FortuneInfo" className={`infoChange ${styles.infoChange_lightHouse}`}>
                            {hasInfo ? menuList.MENU_BTN : '내 정보 입력하기'}
                        </Link>
                        <Link
                            className="unseHistory"
                            to="/lighthouse/fortune-history"
                            style={{
                                display: 'block',
                                color: '#fff',
                                background: 'rgba(255,255,255,0.15)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                textDecoration: 'none',
                                textAlign: 'center',
                                boxSizing: 'border-box'
                            }}
                        >
                            운세 히스토리
                        </Link>
                    </>
                )}

                {isLoggedIn && (
                    <button
                        className="logOutBtn"
                        onClick={handleLogout}
                        style={{
                            background: 'rgba(255,255,255,0.15)',
                            border: '1px solid rgba(255,255,255,0.3)',
                            cursor: 'pointer'
                        }}
                    >
                        로그아웃
                    </button>
                )}

                <div className={`footerInfo ${styles.footerInfo_lightHouse}`}>
                    <ul className="footerList">
                        <li>
                            <span>주식회사 인피니티커넥트</span> 대표 이호원
                        </li>
                        <li>
                            <span>사업자등록번호</span> 456-86-02812
                        </li>
                        <li>
                            <span>주소</span> 경기도 부천시 원미구 중동로254번길로 90, 6층 6100호
                        </li>
                    </ul>
                    <Link to="/lighthouse/AgreePrivacy">개인정보처리방침</Link>
                    <span className="copyright">
                        Copyright © 2025 Infinity Connect - All right reserved
                    </span>
                </div>
            </div>
        </div>
    );
}

function FortuneResult({ menuList }) {
    return (
        <div dangerouslySetInnerHTML={{ __html: menuList.TODAY_SCORE }} />
    );
}

export default SideNav;
